import React from 'react';
import t from 'tcomb-form';

import baseFormFactory from './BaseForm';
import types from './validators/index';
import {ValidatonError} from '../resources/GenericResource';
import {FormImage, ImageUpload} from './FileUpload';

import PhoneFieldComponent from '../components/PhoneFieldComponent';
import TimezoneFieldComponent from '../components/TimezoneFieldComponent';
import GoogleLocationInput from '../components/Form_widgets/GoogleLocationInput';


const StringMax32 = t.subtype(t.Str, function (x) { return x.length <= 32; });
const StringMax128 = t.subtype(t.Str, function (x) { return x.length <= 128; });
const EmailStr = t.subtype(types.email, function (x) { return x.length <= 254; });

const SettingsGeneralFormModel = t.struct({
    name: t.Str,
    email: types.email,
    website: types.url,
    registry_id: t.Str,
    phone: t.Str,
    timezone: t.Str,
    description: t.Str,
    logo: t.maybe(FormImage),
    address: t.Str,
    country: t.maybe(t.Str),
    city: t.maybe(t.Str),
    street: t.maybe(t.Str),
    zip: t.maybe(t.Str),
    lat: t.maybe(t.Num),
    lng: t.maybe(t.Num),
    billing_address: StringMax128,
    billing_country: t.maybe(t.Str),
    billing_city: t.maybe(t.Str),
    billing_street: t.maybe(t.Str),
    billing_zip: t.maybe(t.Str),
    billing_lat: t.maybe(t.Num),
    billing_lng: t.maybe(t.Num),
    billing_email: EmailStr,
    vat_number: StringMax32
});

class FormLayout extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {inputs, value} = this.props;

        return (
            <div>
                <div className="tab-section settings-form">
                    <h2 className="tab-section-title">Company details</h2>
                    <div className="section-content media">
                        <div className="left">
                            <h3 className="label-title">Logo</h3>
                            <div className="upload-container">
                                <div className="form-control form-control-upload">
                                <div className="form-control-upload-content">
                                    </div>
                                    {inputs.logo}
                                </div>
                                <p className="recommended-size">Recommended size: 250x250px</p>
                            </div>
                        </div>
                        <div className="form-cols body">
                            <div className="col">
                                <label className="form-control form-control-text">
                                    <h3 className="label-title">Company name</h3>
                                    {inputs.name}
                                    <span className="error-msg"></span>
                                </label>

                                <label className="form-control form-control-text">
                                    <h3 className="label-title">Company email</h3>
                                    {inputs.email}
                                    <span className="error-msg"></span>
                                </label>

                                <label className="form-control form-control-text">
                                    <h3 className="label-title">Company website</h3>
                                   {inputs.website}
                                    <span className="error-msg"></span>
                                </label>

                            </div>
                            <div className="col">
                                <label className="form-control form-control-text">
                                    <h3 className="label-title">Company tel</h3>
                                    {inputs.phone}
                                </label>
                                <label className="form-control form-control-text">
                                    {inputs.address}
                                    {inputs.lat}
                                    {inputs.lng}
                                    {inputs.country}
                                    {inputs.city}
                                    {inputs.street}
                                    {inputs.zip}
                                </label>
                                <label className="form-control form-control-text">
                                    <h3 className="label-title">Company timezone</h3>
                                    {inputs.timezone}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tab-section">
                    <h2 className="tab-section-title">Company Profile - A brief introduction of your business</h2>
                    <label className="form-control form-control-text form-control-billings">
                        {inputs.description}
                    </label>
                </div>
                <div className="tab-section billing">
                    <h2 className="tab-section-title">Billing details</h2>
                    <div className="col">
                        <label className="form-control form-control-text">
                            <h3 className="label-title">Registered company name</h3>
                            {inputs.vat_number}
                            <span className="error-msg"></span>
                        </label>

                        {inputs.billing_address}
                        {inputs.billing_lat}
                        {inputs.billing_lng}
                        {inputs.billing_country}
                        {inputs.billing_city}
                        {inputs.billing_street}
                        {inputs.billing_zip}
                    </div>
                    <div className="col">
                        <label className="form-control form-control-text">
                            <h3 className="label-title">Billing email</h3>
                            {inputs.billing_email}
                            <span className="error-msg"></span>
                        </label>

                        <label className="form-control form-control-text">
                            <h3 className="label-title">Reg. nr</h3>
                            {inputs.registry_id}
                            <span className="error-msg"></span>
                        </label>
                    </div>
                </div>
            </div>
        );
    }
}

function phoneInputTemplate(locals){
    return (
        <PhoneFieldComponent {...locals}/>
    );
}

function timezoneInputTemplate(locals) {
    return (
        <TimezoneFieldComponent {...locals} />
    )
}

function makeLayout(locals) {
    return <FormLayout {...locals}/>
}

const Form = baseFormFactory(SettingsGeneralFormModel, true, true);

class SettingsGeneralForm extends Form {
    constructor(props) {
        super(props);
        let isValid = true;
        let test = Object.values(props.initialFormData);
        for (var i = 0; i < test.length; i++){
            if (typeof test[i] === 'undefined' || test[i] === ''){
                isValid = false;
                break;
            }
        }

        const value = props.initialFormData;
        this.state = {
            isValid,
            value
        };
    }

    shiftAddressTemplate(locals){
        return <GoogleLocationInput
            callBack={this.handleAddressChange.bind(this)}
            reference={'locationInput'}
            onChange={this.onChange}
            onBlur={this.onBlur.bind(this)}
            types={'address'}
            {...locals}
            placeholder={''}
        />
    }

    billingAddressTemplate(locals){
        return <GoogleLocationInput
            callBack={this.handleBillingAddressChange.bind(this)}
            reference={'billingAddressInput'}
            onChange={this.onChange}
            onBlur={this.onBlur.bind(this)}
            title={'Billing Address'}
            path={'billing_address'}
            types={'address'}
            {...locals}
            placeholder={''}
        />
    }

    findFromComponents(components, component_name, value_location){
            const f = components.filter(v => {
                return v.types.indexOf(component_name) > -1
            });
            if ( f.length > 0 ){
                const result = f[0][value_location];
                if ( typeof result == 'undefined' ){
                    return '';
                }
                return result;
            }
            return '';
        };

    handleAddressChange(place) {
        // TODO: There is a small race condition here - we reset all the address fields on blur event and then after we
        // get response from Google we check the existence of city. If city existed in earlier state value and we got
        // response from Google before the blur event fired then the city check would give us wrong results AND we would
        // empty the fields after adding valid data to state.
        const value = this.state.value;
        value.lat = String(place.geometry.location.lat()).substr(0, 12);
        value.lng = String(place.geometry.location.lng()).substr(0, 12);
        value.country = this.findFromComponents(place.address_components, "country", "short_name");
        value.city = this.findFromComponents(place.address_components, "locality", "long_name");
        // Fall back to sublocality if the results didn't include locality.
        if (!value.city) {
            value.city = this.findFromComponents(place.address_components, "sublocality", "long_name");
        }
        value.street = this.findFromComponents(place.address_components, "route", "long_name");
        const street_number = this.findFromComponents(place.address_components, "street_number", "long_name");
        if (typeof street_number !== 'undefined' && street_number !== '') {
            value.street = street_number + ' ' + value.street;
        }
        value.zip = this.findFromComponents(place.address_components, "postal_code", "long_name");
        value.address = place.formatted_address;
        this.setState({value});
        this.onChange(value);
    }

    handleBillingAddressChange(place) {
        // TODO: There is a small race condition here - we reset all the address fields on blur event and then after we
        // get response from Google we check the existence of city. If city existed in earlier state value and we got
        // response from Google before the blur event fired then the city check would give us wrong results AND we would
        // empty the fields after adding valid data to state.
        const value = this.state.value;
        value.billing_lat = String(place.geometry.location.lat()).substr(0, 12);
        value.billing_lng = String(place.geometry.location.lng()).substr(0, 12);
        value.billing_country = this.findFromComponents(place.address_components, "country", "short_name");
        value.billing_city = this.findFromComponents(place.address_components, "locality", "long_name");
        // Fall back to sublocality if the results didn't include locality.
        if (!value.billing_city) {
            value.billing_city = this.findFromComponents(place.address_components, "sublocality", "long_name");
        }
        value.billing_street = this.findFromComponents(place.address_components, "route", "long_name");
        const street_number = this.findFromComponents(place.address_components, "street_number", "long_name");
        if (typeof street_number !== 'undefined' && street_number !== '') {
            value.billing_street = street_number + ' ' + value.street;
        }
        value.billing_zip = this.findFromComponents(place.address_components, "postal_code", "long_name");
        value.billing_address = place.formatted_address;
        this.setState({value});
        this.onChange(value);
    }

    getOptions() {
        const errors = this.props.errors;

        return {
            auto: 'none',

            template: makeLayout,

            fields: {
                name: {
                    type: 'text',
                    hasError: !!errors,
                    error: errors && (errors['name'] && errors['name'] !== 'Error' ? "Please enter a company name" : null || errors.errors && Object.keys(errors.errors).filter(x => x.indexOf('name') > -1).length ? "Please enter a company name." : null)
                },

                registry_id: {
                    type: 'text',
                    hasError: !!errors,
                    error: errors && errors['registry_id'] ? "Please enter a registry id" : null
                },

                email: {
                    type: 'text',
                    hasError: !!errors,
                    error: errors && errors['email'] ? "Please enter a valid email" : null
                },

                phone: {
                    type: 'text',
                    hasError: !!errors,
                    template: phoneInputTemplate,
                    error: (errors && errors.errors && Object.keys(errors.errors).filter(x => x.indexOf('phone') > -1).length ? errors.errors.phone : null) || (errors && errors['phone'] ? "Please enter a valid phone number (eg +447555555555)" : null)
                },

                timezone: {
                    type: 'text',
                    hasError: !!errors,
                    template: timezoneInputTemplate,
                    error: (errors && errors.errors && Object.keys(errors.errors).filter(x => x.indexOf('timezone') > -1).length ? errors.errors.timezone : null)
                },

                website: {
                    type: 'text',
                    hasError: !!errors,
                    error: errors && errors['website'] ? "Please add a valid company website" : null
                },

                description: {
                    type: 'textarea',
                    hasError: !!errors && errors['description'],
                    error: errors && errors['description'] ? 'Please add a description' : null
                },

                logo: {
                    type: 'file',
                    factory: ImageUpload,
                    hasError: !!errors
                },

                address: {
                    type: 'text',
                    template: this.shiftAddressTemplate.bind(this),
                    hasError: !!errors,
                    error: errors && errors['address'] ? "Please make sure you added an address" : null
                },

                lat: {
                    type: 'hidden'
                },

                lng: {
                    type: 'hidden'
                },

                country: {
                    type: 'hidden'
                },

                city: {
                    type: 'hidden'
                },

                street: {
                    type: 'hidden'
                },

                zip: {
                    type: 'hidden'
                },

                billing_address: {
                    type: 'text',
                    template: this.billingAddressTemplate.bind(this),
                    hasError: !!errors && errors['billing_address'],
                    error: errors && errors['billing_address'] ? 'Please add your billing address' : null
                },

                billing_lat: {
                    type: 'hidden'
                },

                billing_lng: {
                    type: 'hidden'
                },

                billing_country: {
                    type: 'hidden'
                },

                billing_city: {
                    type: 'hidden'
                },

                billing_street: {
                    type: 'hidden'
                },

                billing_zip: {
                    type: 'hidden'
                },

                billing_email: {
                    type: 'text',
                    hasError: !!errors && errors['billing_email'],
                    error: errors && errors['billing_email'] ? 'Please enter a correct email address' : null
                },

                vat_number: {
                    type: 'text',
                    hasError: !!errors && errors['vat_number'],
                    error: errors && errors['vat_number'] ? 'Please add your VAT number' : null
                }
            }
        };
    }

    onBlur(path) {
        const value = this.state.value;
        if (path.indexOf('address') > -1 && value.address.target === null) {
            value.lat = 51.500152;
            value.lng =  -0.126236;
            value.address = null;
        } else if (path.indexOf('billing_address') > -1 && value.billing_address.target === null) {
            value.billing_lat = 51.500152;
            value.billing_lng =  -0.126236;
            value.billing_address = null;
        }

        this.setState({value});
    }

    onChange(value, path) {
        if (path && path.indexOf('address') > -1) {
            const value = this.state.value;
            value.country = '';
            value.city = '';
            value.street = '';
            value.zip = '';
            value.address = '';
        } else if (path && path.indexOf('billing_address') > -1) {
            const value = this.state.value;
            value.billing_country = '';
            value.billing_city = '';
            value.billing_street = '';
            value.billing_zip = '';
            value.billing_address = '';
        }

        if (this.props.onChange) {
            this.props.onChange(value);
        }
        super.onChange(value);
    }

    render() {
        return (
            <div>
                <t.form.Form ref="form" value={this.state.value} type={this.getModel()}
                             options={this.buildOptions()} onChange={this.onChange.bind(this)}/>
            </div>
        );
    }
}

SettingsGeneralForm.propTypes = {
    initialFormData: React.PropTypes.object.isRequired,
    onChange: React.PropTypes.func
};


export default SettingsGeneralForm;



/** WEBPACK FOOTER **
 ** ./app/src/forms/SettingsGeneralForm.js
 **/